const eventClickCategory = (param) => {
  if (typeof window !== 'undefined' && param) {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `promo_category_button`,
      eventCategory: `promo page events`,
      eventAction: `click on ${param?.toLowerCase()}`,
    });
  }
};
export default eventClickCategory;
